import perks from '../json/shared/perks.json'

export const isOwnUser = ( account, user ) => {
	if( typeof account === 'undefined' || !account ){
		return false
	} else if( typeof user === 'object' ){
		return account.userids.indexOf( user.props.id ) !== -1 || account.deletedUserids.indexOf( user.props.id ) !== -1
	} else {
		return account.userids.indexOf( user ) !== -1 || account.deletedUserids.indexOf( user ) !== -1
	}
}

export const animateUsers = ( account ) => {
	return account.users.filter( ( user ) => user.props.animateIcon )
}

export const animateUsersCount = ( account ) => {
	return animateUsers( account ).length
}

export const maxAnimateCount = ( account ) => {
	const baseCount = account.priv.perks[perks.ANIMATE_ICON_SLOT.id] || 0
	return ( baseCount * ( account.props.sub * 5 ) + account.props.sub * 5 ) || baseCount // 5x for subscribers, and +5 for subscribers
}

export const increaseBySubscriberCount = ( baseCount, account ) => {
	return ( baseCount * ( account.props.sub * 5 ) + account.props.sub * 5 ) || baseCount
}

export const getPerkUsages = ( perk, account ) => {
	if( perk === 'ANIMATE_ICON_SLOT' ){
		return account.users.filter( ( user ) => user.props.animateIcon ).length
	}
	return 0
}

export default {
	isOwnUser: isOwnUser,
	animateUsers: animateUsers,
	animateUsersCount: animateUsersCount,
	maxAnimateCount: maxAnimateCount
}
